// extracted by mini-css-extract-plugin
export default {"title":"Services_title__smA++","container":"Services_container__yWgdm","img":"Services_img__WVaql","cardTitle":"Services_cardTitle__yfCxo","cardText":"Services_cardText__-COI0"};